import { useNavigate } from "react-router-dom";
import TextInput from "@scripts/react/components/TextInput";
import { Chip } from "@scripts/react/components/Chip";
import Button from "@scripts/react/components/Button";

interface ModelsHeaderProps {
    searchQuery: string;
    onSearchChange: (value: string) => void;
    totalModels: number;
    filteredModels: number;
    workspaceUrl: string;
}

export const ModelsHeader = ({
    searchQuery,
    onSearchChange,
    totalModels,
    filteredModels,
    workspaceUrl
}: ModelsHeaderProps) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(`/${workspaceUrl}`);
    };

    return (
        <div className="flex flex-col gap-4 bg-white">
            <div className="flex items-center gap-2">
                <h1 className="text-2xl font-semibold text-primary">My Models</h1>
                <Chip type="number" color="gray">
                    {searchQuery && filteredModels !== totalModels
                        ? `${filteredModels} / ${totalModels}`
                        : totalModels}
                </Chip>
            </div>

            <div className="flex gap-2">
                {/* Search bar */}
                <TextInput
                    value={searchQuery}
                    onChange={onSearchChange}
                    placeholder="Search models by name or task..."
                    icon="far fa-search"
                    fullWidth
                />
                <Button onClick={handleBackClick} aria-label="Create Model">
                    <i className="far fa-plus"></i>
                    Create Model
                </Button>
            </div>
        </div>
    );
};
